import { useGetRisksRiskDirectoryId } from "api/generated/risks/risks";

export function useRiskDirectoryStructureQuery(riskDirectoryId: number) {
    return useGetRisksRiskDirectoryId(riskDirectoryId, undefined, {
        query: { select: (response) => response.data },
    });
}
